import { Navigate, useNavigate, useParams } from "react-router-dom";
import { AppLayout } from "../../components/layout/AppLayout";
import { DeletedOpportunitiesPanel } from "../../components/suporte/DeletedOpportunitiesPanel";
import { useAuth } from "../../contexts/AuthContext";

function getStoredCompany() {
  try {
    return JSON.parse(localStorage.getItem("selectedCompany") || "null");
  } catch (_) {
    return null;
  }
}

export function SupportCompanyPage() {
  const { companyId } = useParams();
  const navigate = useNavigate();
  const { companies } = useAuth();
  const storedCompany = getStoredCompany();

  const company =
    companies.find((item) => String(item.id) === String(companyId)) ||
    (storedCompany && String(storedCompany.id) === String(companyId) ? storedCompany : null);

  if (!company) {
    return <Navigate to="/suporte" replace />;
  }

  return (
    <AppLayout>
      <section className="card">
        <div className="section-header">
          <h2>Painel da empresa</h2>
          <button
            className="secondary-button"
            type="button"
            onClick={() => navigate("/suporte")}
          >
            Voltar para empresas
          </button>
        </div>
        <p className="company-header-meta">
          <strong>{company.name}</strong> - ID: {company.id}
        </p>
      </section>

      <DeletedOpportunitiesPanel companyId={company.id} companyName={company.name} />

      <section className="company-sections-grid">
        <article className="card">
          <h3>Contatos</h3>
          <p className="muted-text">
            Placeholder para ações de suporte relacionadas a contatos da empresa.
          </p>
        </article>

        <article className="card">
          <h3>Conversas</h3>
          <p className="muted-text">
            Placeholder para ações de suporte relacionadas a conversas e histórico.
          </p>
        </article>
      </section>
    </AppLayout>
  );
}
